import { HTMLAttributes, ReactNode } from 'react';
import Footer from '~/components/layout/Footer';
import BasicHeader from '~/components/layout/Header/Campaign/BasicHeader';
import CustomizableHeader from '~/components/layout/Header/Campaign/CustomizableHeader';
import Container from '~/components/ui/Container';
import PoweredByAdvieskeuze from '~/components/ui/PoweredByAdvieskeuze';
import {
  hasHiddenHeaderFooter,
  hasPoweredByLogo,
} from '~/helpers/campaignUtils';
import { cn } from '~/helpers/utils';
import { useIframeHeight } from '~/hooks/useIframeHeight.ts';
import type { CampaignProps } from '~/types/Campaign';

interface CampaignLayoutProps extends HTMLAttributes<HTMLDivElement> {
  breadcrumbs?: ReactNode;
  campaign: CampaignProps;
  isSearchPage?: boolean;
}

function CampaignLayout({
  breadcrumbs,
  children,
  className,
  campaign,
  isSearchPage,
}: CampaignLayoutProps) {
  useIframeHeight();

  const { logoUrl } = campaign;

  return (
    <div
      className={cn(
        'campaign-layout-wrapper relative flex flex-col',
        className
      )}
    >
      {!hasHiddenHeaderFooter(campaign) && !logoUrl && <BasicHeader />}

      {logoUrl && <CustomizableHeader imageUrl={logoUrl} />}

      <main className="flex-grow">
        {!!breadcrumbs && (
          <Container className="relative z-10 py-4 md:py-8">
            {breadcrumbs}
          </Container>
        )}

        {children}

        {!isSearchPage && hasPoweredByLogo(campaign) && (
          <PoweredByAdvieskeuze />
        )}
      </main>

      {!hasHiddenHeaderFooter(campaign) && <Footer />}
    </div>
  );
}

export default CampaignLayout;
